import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.glass-toggle-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--glass-toggle-slider' )[0], {
          type: 'fade',
          pagination: false,
          arrows: false,
          perPage: 1,
          speed: 1000,
          drag: false,
          breakpoints: {
            1023: {
              drag: true,
            },
          },
        } );

        $( '.gts__splide__pagination__page' ).on( 'click', function() {
          splide.go( $( this ).parent().index() );

          setTimeout( function() {
            $( component ).find( '.splide__slide' ).eq( $( this ).parent().index() ).find( '.gts__splide__pagination__page' ).attr( 'tab-index', 0 ).trigger( 'focus' );
          }, 1000 );
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'glass-toggle-slider', COMPONENT );
} )( app );
